import {AdvancedStatementApi, EarnedStatementsApi} from 'Agent/Commissions/api/api';
import {CommissionFilter} from 'Agent/Commissions/ducks/commission';
import {getAxiosConfig, getUrlFromUri, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {Sort, toSortQuerystringParams} from 'Shared/components/PagedView/Table/Sort';
import axios from 'Shared/utilities/axiosInstance';

export const earnedCommissionsRootUri = '/commissions/earnedStatements';
export const advancedCommissionsRootUri = '/commissions/advancedStatements';

const earnedStatementsApi = new EarnedStatementsApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);
const advancedStatementApi = new AdvancedStatementApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const getEarnedCommissions = (
  agentNumbers: string[],
  isNewYork: boolean,
  encryptedIdentifier: string,
  filter?: CommissionFilter,
  sort?: Sort
) =>
  withCancellation(cancelToken =>
    earnedStatementsApi.searchEarnedCommissions('1', {
      params: {agentNumbers, isNewYork, encryptedIdentifier, ...filter, ...(sort && toSortQuerystringParams(sort))},
      ...getAxiosConfig(cancelToken, false),
    })
  ).then(handleResponse);

const getAdvancedCommissions = (
  agentNumbers: string[],
  isNewYork: boolean,
  encryptedIdentifier: string,
  filter?: CommissionFilter,
  sort?: Sort
) =>
  withCancellation(cancelToken =>
    advancedStatementApi.searchAdvancedCommissions('1', {
      params: {agentNumbers, isNewYork, encryptedIdentifier, ...filter, ...(sort && toSortQuerystringParams(sort))},
      ...getAxiosConfig(cancelToken, false),
    })
  ).then(handleResponse);

const fetchSisenseCommissions = async () => {
  const axiosConfig = getAxiosConfig();
  const result = await axios.post(getUrlFromUri(`/api/user/v1/sisenseUser`), null, {
    ...axiosConfig,
    headers: {
      ...axiosConfig.headers,
    },
  });
  return result;
};

export const getSisenseCommissions = () => {
  return fetchSisenseCommissions().then(data => {
    if (data) {
      return data.data;
    }
  });
};

export default {
  getAdvancedCommissions,
  getEarnedCommissions,
  getSisenseCommissions,
};
